export function AiPersonalWorkflowAssistantPage(): JSX.Element {
  return (
    <main style={{ padding: "32px", maxWidth: "760px", margin: "0 auto" }}>
      <h1>AI個人ワークフロー継続アシスタント</h1>
      <p>
        目的ごとのAIエージェント、継続記録、振り返り、次の行動提案をまとめる新しい利用体験です。
      </p>
      <section aria-label="workflow features">
        <h2>できること</h2>
        <ul>
          <li>目的別AIエージェントの作成</li>
          <li>継続中のテーマや記録の管理</li>
          <li>次に行う行動の整理</li>
        </ul>
      </section>
    </main>
  );
}
